import React from "react";
import "./index.css";

export function SquareLoadingSkeleton(){
  return (
    <div className="square-section-skeleton skeleton-animation"></div>
  )
}
